<app-loaing *ngIf="loading"></app-loaing>

<div *ngIf="!loading" class="cardsP mat-typography">
    <div class="row" >
      <ng-container *ngFor="let producto of productosX, let i = index" >
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3" *ngIf="(producto.category_id === this.categoriaInput) && (producto.isVisible)">
          <div  id="productosDiv" class="tarjetas row animated fadeIn order-card">

              <div class="boxI col-4 col-sm-4 col-md-4 col-lg-5 col-xl-5" style="padding-left: 0px !important; padding-right: 0px !important;">
                  <img [src]="producto.imagenes[0].mini" (click)="openModal(i, contenido)" alt="..." data-toggle="modal" data-target="#staticBackdrop">
                  <img *ngIf="producto.controlStock == 1 && 0 >= producto.stock" src="../../../assets/images/agotado.png" alt="...">
              </div>

              <div class="card-tex col-8 col-sm-8 col-md-8 col-lg-7 col-xl-7">
                  <div class="row pos1">
                      <small><p style="padding: 5px 0px 0px 10px !important;" class="card-title">{{producto.title}}</p></small>
                  </div>
                  <div class="row pos2">
                      <div *ngIf="producto.description" class="col-12"><small>{{verMas(producto.description)}}...</small> </div>
                      <div *ngIf="!producto.description" class="col-12">
                          <font size="1"><small>.</small></font>
                      </div>
                      <!-- <div *ngIf="!producto.description" class="col-12 alert alert-light" role="alert"><small>No hay descripción para este producto.</small></div> -->
                  </div>
                  <div class="row pos3" *ngIf="ecomerce == '0'">
                      <div class="col-3"></div>
                      <div class="col-6 tex-price">{{ producto.priceConImpuesto | currency: (datosTienda)?datosTienda.config_ticket.moneda + ' ':'$ ' +' '}}</div>
                      <div class="col-3"></div>
                  </div>
                  <div class="row  pos3" *ngIf="ecomerce == '1'">
                      <div class="col-2 col-sm-4 col-md-4 col-lg-4 col-xl-4"><img src="../../../assets/images/i_minus.png" class="logo-plus" alt="..." (click)="agregarProducto(i,false)"></div>
                      <div class="col-2 col-sm-4 col-md-4 col-lg-4 col-xl-4 tex-price">{{producto.cantidad}}</div>
                      <div class="col-2 col-sm-4 col-md-4 col-lg-4 col-xl-4"><img src="../../../assets/images/i_plus.png" class="logo-plus" alt="..." (click)="agregarProducto(i,true)"></div>
                      <div class="col-6 col-sm-12 col-md-12 col-lg-12 col-xl-12 tex-price order">{{ producto.priceConImpuesto | currency: (datosTienda)?datosTienda.config_ticket.moneda + ' ':'$ ' +' '}}</div>
                  </div>
              </div>
          </div>
          <ngb-alert *ngIf="productosX[i].alert == 1" (close)="productosX[i].alert = 0" style="font-family: Montserrat-Regular; border-radius: 12px;">
              No hay mas existencias de este producto.
          </ngb-alert>
      </div>
      </ng-container>

    </div>
    <ng-template #contenido let-modal>
        <div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content" *ngIf="datosTienda">
                    <div class="modal-header">
                        <h5 class="modal-title" id="staticBackdropLabel">{{this.productosX[indexM].title}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <img src="{{this.productosX[indexM].imagenes[0].imagen}}" style=" width: 100%; border-radius: 12px 12px 12px 12px;" alt="...">

                            </div>
                            <!-- <div class="col-12">
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to
                                    make a type specimen book. </p>
                            </div> -->
                            <div *ngIf="productosX[indexM].description" class="col-12">
                                <p> {{productosX[indexM].description}}</p>
                            </div>
                            <div *ngIf="!productosX[indexM].description" style="font-family: 'Montserrat-Regular';" class="col-12 alert alert-light" role="alert">

                            </div>
                            <hr>
                        </div>
                    </div>
                    <div *ngIf="ecomerce == '1'" class="modal-footer">
                        <div class="row">
                            <div class="col-1 center-block text-center"><img src="../../../assets/images/i_minus.png" style="height: 16px; width: 16px;" alt="..." (click)="agregarProducto(indexM,false)"></div>
                            <div class="col-2 center-block text-center">{{this.productosX[indexM].cantidad}}</div>
                            <div class="col-1 center-block text-center"><img src="../../../assets/images/i_plus.png" style="height: 16px; width: 16px;" alt="..." (click)="agregarProducto(indexM,true)"></div>
                            <div class="col-4 center-block text-center"><b>{{this.productosX[indexM].price | currency: (datosTienda)?datosTienda.config_ticket.moneda + ' ':'$ ' +' '}}</b></div>
                            <div class="col-3 center-block text-center">
                                <B (click)="agregarProducto(indexM,true)">AGREGAR</B>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="ecomerce == '0'" class="modal-footer">
                        <div class="row">
                            <div class="col-3 center-block text-center"></div>
                            <div class="col-6 center-block text-center"><b>{{this.productosX[indexM].price | currency: (datosTienda)?datosTienda.config_ticket.moneda + ' ':'$ ' +' '}}</b></div>
                            <div class="col-3 center-block text-center"></div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

</div>
<div *ngIf="error" class="alert alert-danger animated fadeIn" role="alert">
    No se encontraron productos para esta categoria.
</div>

<app-carrito *ngIf="indCarrito" (finalizarPedido)="cerrarCatalogo( $event )" [productos]="productosX" [idComercio]="idComercio" [cantidadProd]="numProductos" [nombre_tienda]="nombre_tienda" [rnc]="rnc" [cedula]="cedula"
 (click)="toggleCarrito(true)"></app-carrito>
